import getLocaleValue from 'services/LocalizationService';

const localeBundlePlugin = {
    install: (Vue) => {
        Vue.prototype.$getLocale = function (key, replacePairs = {}) {
            return getLocaleValue(this.$store.getters.getLocaleDictionary)(key, replacePairs);
        };
    },
};

export default localeBundlePlugin;
